import { clsx } from 'clsx/lite'
import React, { type PropsWithChildren } from 'react'

type CardPopularProps = {
  isPopular: boolean
}

export const CardPopular: React.FC<CardPopularProps & PropsWithChildren> = ({
  isPopular,
  children,
}) => {
  if (!isPopular) {
    return children
  }

  return (
    <div
      className={clsx(
        'relative flex w-fit flex-col items-center overflow-hidden rounded-[15px] px-1 pb-1',
        'bg-[linear-gradient(309deg,_rgba(255,_255,_255,_0.00)_6%,rgba(171,_217,_255,_0.50)_171%),_linear-gradient(48deg,_rgba(255,_255,_255,_0.00)_6%,rgba(176,_235,_100,_0.30)_166%)]'
      )}
    >
      <span className="z-10 py-3 text-085">La plus populaire</span>
      {children}
    </div>
  )
}
